/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */

 export const videos = [
  {
    _id: "v_mZ1VnG0tw",
    image: "https://img.youtube.com/vi/v_mZ1VnG0tw/maxresdefault.jpg",
    length: "9.00",
    icon:
      "https://yt3.ggpht.com/ytc/AKedOLSLhQeRhK1A6sfO7xgfThe_QcQRd_CHGnBiIFf3_Q=s68-c-k-c0x00ffffff-no-rj",
    title: "Top 8 Must Have Wearable Tech Devices in 2020",
    channelName: "Future 4K",
    views: "18K",
    isTrending: false,
    category: "wearables",
    description:
      "Ever since technology has become a crucial part of our life, we all seem to be inclining towards smaller and smarter tech gadgets, So in this video we introduce you newest and coolest wearable gadgets in 2020"
  },
  {
    _id: "dHwtvXIRdi0",
    image: "https://img.youtube.com/vi/dHwtvXIRdi0/maxresdefault.jpg",
    length: "7.45",
    icon:
      "https://yt3.ggpht.com/EYXEN3n0cfYgs_zDqlSVk8JY1y6gLrzfmdV17uce1zkMEKRoH7VlLwaptPBh6zBk_ie-c7Qw=s68-c-k-c0x00ffffff-no-rj",
    title: "Top 10+ Best Upcoming Mobile Phone Launches⚡March 2022",
    channelName: "Trakin Tech",
    views: "1M",
    isTrending: false,
    category: "phone",
    description:
      "Friends, The most awaited video of the month is here - upcoming smartphones. In today’s video we are taking a look at all the upcoming smartphones that are launching in March 2022. So do watch this video till the end and make sure you like and share this video with your friends and family. "
  },
  {
    _id: "3ywADcxe6JM",
    image: "https://img.youtube.com/vi/3ywADcxe6JM/maxresdefault.jpg",
    length: "10:20",
    icon:
      "https://yt3.ggpht.com/ytc/AKedOLSLzBlLalLFEXgvGHr6f9yBm9Y8PrJMXZC_hxTTlQ=s68-c-k-c0x00ffffff-no-rj",
    title: "How To Buy a Perfect Smartphone in 2022!",
    channelName: "Tech Burner",
    views: "2.1M",
    isTrending: false,
    category: "phone",
    description: "Sahi phone lene ki Ninja techniques!"
  },
  {
    _id: "ya0de3ucRB4",
    image: "https://img.youtube.com/vi/ya0de3ucRB4/maxresdefault.jpg",
    length: "8:11",
    icon:
      "https://yt3.ggpht.com/gBZ6aUsFE-je2mVwL09-w288a265LtupuqoePjttH9UC5vcU8oOO73CFtkI2esBlQbqMVsLZs9o=s88-c-k-c0x00ffffff-no-rj",
    title: "STOP Your Mistakes & Buy Best Laptop ............!!",
    channelName: "Gyan Therapy",
    views: "1.8M",
    isTrending: false,
    category: "laptop",
    description: `I always got your comments like 
    Best Gaming laptop
    Best laptop for video editing
    Best laptop under 50000 rupees etc
    In this video i talked about 5 tips to buy new laptop or you can say 5 mistakes you are doing while buying new laptop.`
  },
  {
    _id: "hoZF_yRZYxs",
    image: "https://img.youtube.com/vi/hoZF_yRZYxs/maxresdefault.jpg",
    length: "17.09",
    icon:
      "https://yt3.ggpht.com/ytc/AKedOLR8QcIhAvxAthtTvj_u0ZYtkWuooX6Y0axLaoumDw=s88-c-k-c0x00ffffff-no-rj",
    title: "Top 10 Best Smart Rings | Smartest Wearable",
    channelName: "Top 10 Zone",
    views: "485K",
    isTrending: false,
    category: "wearables",
    description:
      "Top 10 Best Smart Ring for Men and Women that will let you track your fitness goal or pay without using your wallet, alert you about you social media notification and much more."
  },
  {
    _id: "peBzo2rvzgc",
    image: "https://img.youtube.com/vi/peBzo2rvzgc/maxresdefault.jpg",
    length: "6:50",
    icon:
      "https://yt3.ggpht.com/EYXEN3n0cfYgs_zDqlSVk8JY1y6gLrzfmdV17uce1zkMEKRoH7VlLwaptPBh6zBk_ie-c7Qw=s68-c-k-c0x00ffffff-no-rj",
    title: "Top 5 Best 5G Smartphones Under ₹20000 Budget⚡March 2022",
    channelName: "Trakin Tech",
    views: "1M",
    isTrending: true,
    category: "phone",
    description:
      "Friends, Welcome To Another Helpful Video- Here are our top picks for the best 5G smartphones for a budget of around ₹20000 rupees-While these are my recommendations, I am sure the majority of you will agree with me because we have done extensive research before making this video. Do let us know if you agree with our list and if you do, make sure you like and subscribe to our channel because we keep bringing you such awesome quality videos on a regular basis."
  },
  {
    _id: "pMav7RFU1dE",
    image: "https://img.youtube.com/vi/pMav7RFU1dE/maxresdefault.jpg",
    length: "8.11",
    icon:
      "https://yt3.ggpht.com/ytc/AKedOLT6Lun0QPpS6uFhuTY0BGe__XrOJKqmT8sHctrP5Q=s88-c-k-c0x00ffffff-no-rj",
    title: "My Pick for the Best Budget Laptops!",
    channelName: "GadgetByte",
    views: "624K",
    isTrending: true,
    category: "laptop",
    description:
      "Hi everyone, we have been testing various budget laptops of 2021. In this video, we have listed the best of the bunch. Find out my pick of the best laptop under $700, INR. 65,000 and under 1 lakh in Nepal. "
  },
  {
    _id: "hrLX8Woiak8",
    image: "https://img.youtube.com/vi/hrLX8Woiak8/maxresdefault.jpg",
    length: "1.26",
    icon:
      "https://yt3.ggpht.com/ytc/AKedOLQvj9uoUAULnSF4M8rCyqbg_bd4STBzr6BigkyA=s88-c-k-c0x00ffffff-no-rj",
    title: "What is Wearable Tech and what can I do with it?",
    channelName: "Funk-e Studios",
    views: "29K",
    isTrending: false,
    category: "wearables",
    description:
      "Wearables are technological devices you wear on your body, but what can they actually do?"
  },
  {
    _id: "t7hyafS-0MY ",
    image: "https://img.youtube.com/vi/t7hyafS-0MY/maxresdefault.jpg",
    length: "8.00",
    icon:
      "https://yt3.ggpht.com/ytc/AKedOLTQGRWqwoJ5mY6aSUe5PPE3QaYB8A_cwi-uY7-pzw=s68-c-k-c0x00ffffff-no-rj",
    title: "10 Useful Laptop Gadgets in 2022!",
    channelName: "Beebom",
    views: "393K",
    isTrending: true,
    category: "laptop",
    description:
      "Ever since COVID, we have been using our laptops a lot more, and in this video, we show you 10 useful laptop gadgets that will make your life a whole lot easier. "
  },
  {
    _id: "ART5DJD6FaU",
    image: "https://img.youtube.com/vi/ART5DJD6FaU/maxresdefault.jpg",
    length: "10.20",
    icon:
      "https://yt3.ggpht.com/ytc/AKedOLTcBca1zPZe5IRQwMSMQR7_0FWhVESTt5Aw1S0atQ=s48-c-k-c0x00ffffff-no-rj",
    title: "5 Smart Wearable Technology You Must Have",
    channelName: "Gadget Inspiration",
    views: "1.8K",
    isTrending: true,
    category: "wearables",
    description:
      "5 Smart Wearable Technology You Must Have"
  },
  {
    _id: "78DtfUXydv4",
    image: "https://img.youtube.com/vi/78DtfUXydv4/maxresdefault.jpg",
    length: "5.55",
    icon:
      "https://yt3.ggpht.com/ytc/AKedOLT1mtYV-xdNSt6oRm3DlE6S6hVN5KEKB6GBFygE=s48-c-k-c0x00ffffff-no-rj",
    title: "Latest Wearable Tech 2021 | Wearable Technology",
    channelName: "Product District",
    views: "1.8K",
    isTrending: true,
    category: "wearables",
    description: "One area in tech innovation that has been gaining more attention today is the wearable technology. These technology products are smartly integrated in existing wearable items that we use every day – which is why the wearable technology is so powerful."
  },
  {
    _id: "vCvwPAZx_o0",
    image: "https://img.youtube.com/vi/vCvwPAZx_o0/maxresdefault.jpg",
    length: "7.42",
    icon:
      "https://yt3.ggpht.com/ytc/AKedOLRrHcrqMj019-QQ392PvgAyrlRNxZBGyVFmSMbeMQ=s48-c-k-c0x00ffffff-no-rj",
    title: "The Future of Tech is Wearables",
    channelName: "Concerning Reality",
    views: "14.9K",
    isTrending: true,
    category: "wearables",
    description: "Tech companies are trying to take over the world. I’m not just being alarmist, that’s the current business model of tech companies as they try to be the one stop shop for your life. Don’t believe me? Let’s take a closer look at just what tech companies have been up to."
  },
  {
    _id: "gA3mM2w2hRg",
    image: "https://img.youtube.com/vi/gA3mM2w2hRg/maxresdefault.jpg",
    length: "12:35",
    icon:
      "https://yt3.ggpht.com/EYXEN3n0cfYgs_zDqlSVk8JY1y6gLrzfmdV17uce1zkMEKRoH7VlLwaptPBh6zBk_ie-c7Qw=s68-c-k-c0x00ffffff-no-rj",
    title: "Smartphone Buying Guide 2021 ⚡ Find The Perfect Smartphone For You",
    channelName: "Trakin Tech",
    views: "2.1M",
    isTrending: true,
    category: "phone",
    description:
      "Doston Har dusre teesre din ek smartphone launch ho raha hai aur jab aap smartphone lete ho toh 15-20 dino ke baad aise lagtaa hai ki thodi der ruk jaana chahiye tha"
  },
  {
    _id: "XADAYYCnp4w",
    image: "https://img.youtube.com/vi/XADAYYCnp4w/maxresdefault.jpg",
    length: "12.01",
    icon:
      "https://yt3.ggpht.com/EYXEN3n0cfYgs_zDqlSVk8JY1y6gLrzfmdV17uce1zkMEKRoH7VlLwaptPBh6zBk_ie-c7Qw=s68-c-k-c0x00ffffff-no-rj",
    title: "Detailed Laptop Buying Guide 2022⚡Don't Miss This Video",
    channelName: "Trakin Tech",
    views: "492K",
    isTrending: true,
    category: "laptop",
    description: "Friends, welcome to yet another amazing buying guide video. In today's video we are discussing which laptop should you buy and how you can get the best bang for you buck, So do watch this video till the end to know everything."
  },
  {
    _id: "u8tnYt30L-A",
    image: "https://img.youtube.com/vi/u8tnYt30L-A/maxresdefault.jpg",
    length: "13.54",
    icon:
      "https://yt3.ggpht.com/ytc/AKedOLQGnY6McntoY-eWaRDI047FWFqj7pVlw2nBfkwz7w=s48-c-k-c0x00ffffff-no-rj",
    title: "How wearable technology will change our lives | Gonzalo Tudela | TEDxSFU",
    channelName: "TEDx Talks",
    views: "64K",
    isTrending: true,
    category: "wearables",
    description: "This talk was given at a local TEDx event, produced independently of the TED Conferences. Gonzalo is the CEO & Co-Founder of Vandrico, a technology company that enables wearable technology in the workplace. Gonzalo believes that wearable technology is something that will change our lives in the present, and in the coming future."
  },
  {
    _id: "DppJZQJ9n0g",
    image: "https://img.youtube.com/vi/DppJZQJ9n0g/maxresdefault.jpg",
    length: "10.22",
    icon:
      "https://yt3.ggpht.com/ytc/AKedOLSoumTYdT8sN5SCdf3sU5O4kC7qjJcHeguRvZ6Erg=s48-c-k-c0x00ffffff-no-rj",
    title: `Top 10+ Upcoming Mobile Phones May 2022 🇮🇳 | Crazy Flagship Killer "BUDGET ME"`,
    channelName: "Gizmo Gyan",
    views: "50K",
    isTrending: true,
    category: "phone",
    description:
      "Dosto aaj ki video me maine aapko kuch smartphones bataye hai jo aapko May 2022 me dekhne ko mil jayenge to aapko mast wale flagship killer milenge wo bhi kam price pe :)"
  },
  {
    _id: "WN28MKAK-fA",
    image: "https://img.youtube.com/vi/WN28MKAK-fA/maxresdefault.jpg",
    length: "8.58",
    icon:
      "https://yt3.ggpht.com/ytc/AKedOLQGnY6McntoY-eWaRDI047FWFqj7pVlw2nBfkwz7w=s48-c-k-c0x00ffffff-no-rj",
    title: "Wearable Technologies: The New Normal in Healthcare | Noushin Nasiri | TEDxBlighStreet",
    channelName: "TEDx Talks",
    views: "8.7K",
    isTrending: false,
    category: "wearables",
    description: "What if your wearable device could save your life? Nanotechnologist Dr Noushin Nasiri asks what wearable technology can do for future of healthcare, by empowering us with the ability to monitor our own wellness before we develop illness, and to help our healthcare systems become more proactive and predictive."
  },
  {
    _id: "1mS99Gmw1sI",
    image: "https://img.youtube.com/vi/1mS99Gmw1sI/maxresdefault.jpg",
    length: "11.58",
    icon:
      "https://yt3.ggpht.com/ytc/AKedOLSLzBlLalLFEXgvGHr6f9yBm9Y8PrJMXZC_hxTTlQ=s68-c-k-c0x00ffffff-no-rj",
    title: "This Laptop Has Special Gaming Features",
    channelName: "Tech Burner",
    views: "1.9M",
    isTrending: false,
    category: "laptop",
    description: `OMEN 16" with Intel Core i7 Processor ka gaming Laptop aagaya hai Aur iske mazedar gaming  features try kar liye jaye`
  },
  {
    _id: "tC6FtVKXNhc",
    image: "https://img.youtube.com/vi/tC6FtVKXNhc/maxresdefault.jpg",
    length: "10.29",
    icon:
      "https://yt3.ggpht.com/oSawoFfsLNYpRbz0_8vCldPBwNcbWeedY5FFMMqPyymExZWFc7x_xq1P_AoVBU9via_A7d61iiE=s176-c-k-c0x00ffffff-no-rj",
    title: "Best Upcoming Laptops in India 2022 😍",
    channelName: "PC-Talk with Vikram",
    views: "35K",
    isTrending: false,
    category: "laptop",
    description: "Hello Everybody, Here I am with another list of best upcoming laptops in India 2022. Watching this full will be very helpful if you are planning to a buy new laptop in 2022. "
  },
  {
    _id: "zmvAHh-sKws",
    image: "https://img.youtube.com/vi/zmvAHh-sKws/maxresdefault.jpg",
    length: "9.43",
    icon:
      "https://yt3.ggpht.com/gBZ6aUsFE-je2mVwL09-w288a265LtupuqoePjttH9UC5vcU8oOO73CFtkI2esBlQbqMVsLZs9o=s88-c-k-c0x00ffffff-no-rj",
    title: "POLED Display is Good or NOT *AMOLED vs OLED vs POLED Display*",
    channelName: "Gyan Therapy",
    views: "321K",
    isTrending: true,
    category: "phone",
    description: `This video explained about about POLED ov OLED Display OLED vs AMOLED Display Amoled vs Super Amoled Display
    LG vs Samsung Display
    Thanks for watching`
  },
  {
    _id: "vRs-FrmFhos",
    image: "https://img.youtube.com/vi/vRs-FrmFhos/maxresdefault.jpg",
    length: "8.02",
    icon:
      "https://yt3.ggpht.com/gHm1T5I1vA-ZB9Nwh7MQPMlZ8o63Qmt6b5PQZKs7-eeo85dtkmskwOyQ7_Jbf2Y6bzmcDabsIg=s48-c-k-c0x00ffffff-no-rj",
    title: "The hotly anticipated laptops coming in 2022",
    channelName: "CNET",
    views: "34K",
    isTrending: false,
    category: "laptop",
    description: "Dan Ackerman lists some of the trends and laptops he can't wait for this year."
  },
];

